import React, { useState, useRef, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container,
    Spinner
} from 'react-bootstrap'

// react router
import { Link } from 'react-router-dom'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// includes
import CouponsFormContentView from './Includes/CouponsFormContentView'

// APIs
import { addCoupon } from 'utlis/Apis/Coupons_API'
import { getCategories, cancelGetCategoriesApi } from 'utlis/Apis/Categories_API'
import { getBrands, cancelGetBrandsApi } from 'utlis/Apis/Brands_API'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    COUPON_ADDED_SUCCESSFULLY,
    ERROR_WHILE_CREATING_COUPON,
} from 'utlis/AppMessages/AppMessages'

function CreateCoupon(props) {
    // refs
    const submitButtonRef = useRef(null)

    // states
    const [createButtonDisable, setCreateButtonDisable] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)

    const [categoriesList, setCategoriesList] = useState([])
    const [brandsList, setBrandsList] = useState([])

    // getting categories
    useEffect(() => {
        let URLParams = `limit=-1`
        getCategories(props.currentUser.userToken, URLParams).then(res => {
            const resData = res.data

            // if request succesfull
            if (resData && resData.success) {
                const filteredData = resData?.data?.map(item => {
                    return { value: item.category_id, label: item.category_name }
                })
                setCategoriesList(filteredData)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategories `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
        return () => {
            cancelGetCategoriesApi()
        }
    }, [props.currentUser.userToken])

    // getting brands
    useEffect(() => {
        let URLParams = `limit=-1`
        getBrands(props.currentUser.userToken, URLParams).then(res => {
            const resData = res.data
            // if request succesfull
            if (resData && resData.success) {
                const filteredData = resData?.data?.map(item => {
                    return { value: item.manufacturer_id, label: item.manufacturer_name }
                })
                setBrandsList(filteredData)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        })
        return () => {
            cancelGetBrandsApi()
        }
    }, [props.currentUser.userToken])

    // initial form values
    const initialCreateFormValues = {
        couponCode: "",
        couponDiscountType: "",
        couponDiscountPercent: "",
        couponDiscountValue: "",
        couponExpiryDate: "",
        couponCategories: "",
        couponBrands: "",
        couponMinOrderAmount: "",
        couponStatus: "1",
        couponAutoApply: false,
        couponFreeShiping: false,
        couponSingleUse: false,
        couponSingleUsePerUser: false,
    }

    // handle form validations
    const createFormValidationSchema = Yup.object().shape({
        couponCode: Yup.string().required('This field is required'),
        couponDiscountType: Yup.string().required('This field is required'),
        couponDiscountPercent: Yup.string().when('couponDiscountType', {
            is: "percent",
            then: Yup.string().required('This field is required')
        }),
        couponDiscountValue: Yup.string().when('couponDiscountType', {
            is: "value",
            then: Yup.string().required('This field is required')
        }),
        couponExpiryDate: Yup.string().required('This field is required'),
        couponCategories: Yup.string(),
        couponBrands: Yup.string(),
        couponMinOrderAmount: Yup.string(),
        couponAutoApply: Yup.string(),
        couponFreeShiping: Yup.string(),
        couponStatus: Yup.string(),
        couponSingleUse: Yup.bool(),
        couponSingleUsePerUser: Yup.bool(),
    }, [['couponDiscountPercent', 'couponDiscountValue']])

    // handle form submmision
    const onCreateFormSubmit = values => {
        if (values) {
            // enabling global loading
            setGlobalLoading(true)

            // enabling the button and enabling loading
            setCreateButtonDisable(true)
            setCreateButtonLoading(true)

            // saving the data in the database
            const dataToBeSaved = {
                coupon_code: values.couponCode,
                discount_percent: (values.couponDiscountType === "percent") ? 1 : 0,
                discount_value: (values.couponDiscountType === "percent") ? values.couponDiscountPercent : values.couponDiscountValue,
                expiry_date: values.couponExpiryDate,
                category_ids: values.couponCategories,
                vendor_ids: values.couponBrands,
                minimum_order_amount: values.couponMinOrderAmount,
                is_active: values.couponStatus,
                auto_apply: values.couponAutoApply,
                free_shipping: values.couponFreeShiping,
                single_use: values.couponSingleUse,
                single_use_per_user: values.couponSingleUsePerUser,
            }

            // console.log("coupons data to be saved ", dataToBeSaved)

            // saving data
            addCoupon(props.currentUser.userToken, dataToBeSaved).then(res => {
                // disabling global loading
                setGlobalLoading(false)

                const addingData = res.data

                // if request is success
                if (addingData.success) {
                    // disabling the button loading
                    setCreateButtonLoading(false)

                    // scrolling the window to top
                    window.scrollTo(0, 0)

                    // resetting the form
                    formik.resetForm()

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(COUPON_ADDED_SUCCESSFULLY, {
                        autoClose: 2000,
                        onClose: () => {
                            // redirecting to coupons
                            props.history.push('/catalog/coupons', {
                                shouldReload: true
                            })
                        }
                    })
                }

                // if request is not succeed
                if (addingData.error) {
                    console.log(ERROR_WHILE_CREATING_COUPON, res)

                    // enabling the button and disabling loading
                    setCreateButtonDisable(false)
                    setCreateButtonLoading(false)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_CREATING_COUPON, {
                        autoClose: 3000,
                        onClose: () => {
                            // enabling the button and disabling loading
                            setCreateButtonDisable(false)
                        }
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} addCoupon `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling global loading
                        setGlobalLoading(false)

                        // disbling the button and enabling loading
                        setCreateButtonDisable(false)
                        setCreateButtonLoading(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialCreateFormValues,
        validationSchema: createFormValidationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true
    })

    // handle button submission
    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        // triggering click on submit button
        submitButtonRef.current.click()
    }

    // handle expiry date change
    const handleDateChange = value => {
        if (value) {
            const selectedDate = new Date(value)
            let date = selectedDate.getDate()
            let month = selectedDate.getMonth() + 1
            let year = selectedDate.getFullYear()

            let finalDate = `${year}-${month}-${date}`

            // setting the expiry date value in the hidden input
            formik.setFieldValue("couponExpiryDate", finalDate)
        }
    }

    // handle category change
    const handleCategoryChange = value => {
        if (value) {
            const filteredValue = value.map(item => item.value)

            // setting the category value in the hidden input
            formik.setFieldValue("couponCategories", filteredValue.toString())
        }
    }

    // handle brand change
    const handleBrandChange = value => {
        if (value) {
            const filteredValue = value.map(item => item.value)

            // setting the brand value in the hidden input
            formik.setFieldValue("couponBrands", filteredValue.toString())
        }
    }

    return (
        <section id="app-coupons__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-coupons__create-details">
                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper mb-3">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Create Coupon</p>
                        <p className="app-desc">
                            Create a Coupon.
                        </p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <CouponsFormContentView
                                formik={formik}
                                parentProps={props}
                                handleDateChange={handleDateChange}

                                categoriesList={categoriesList}
                                handleCategoryChange={handleCategoryChange}

                                brandsList={brandsList}
                                handleBrandChange={handleBrandChange}
                            />

                            {/* app card : bottom-bar */}
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to="/catalog/coupons" className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={createButtonDisable}
                                        onClick={handleFormSubmission}>
                                        {
                                            createButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Create Coupon</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CreateCoupon)